<template>
  <div class="exudative-section">
    <span class="accordion-title">
      {{ $t("accordion_exudative_title") }}
    </span>
    <AccordionVideoContainer :videoIds="['325442598']" />
    <ListWithArrows
      :entriesLeft="[
        'accordion_exudative_arrow_list_1',
        'accordion_exudative_arrow_list_2',
        'accordion_exudative_arrow_list_3',
      ]"
      :entriesRight="[
        'accordion_exudative_arrow_list_4',
        'accordion_exudative_arrow_list_5',
      ]"
    />
    <ScientificInformationCardRow :count="2" prefix="accordion_exudative" />
    <ProductsForIntervention
      :leftItems="['20402-411', '20402-410', '20402-401', '20402-402']"
      :leftInformation="['accordion_exudative_products_information_1']"
      :leftButtonLink="
        'https://de.erbe-med.com/productfinder/index.php?openurl=PLM_PRODUKTKATEGORIE%3DInstrument%7CPLM_PRODUKTGRUPPE%3DFlexible%20Sonden%7CPLM_PRODUKTUNTERGRUPPE%3DERBECRYO%202&language=en'
      "
      :rightItems="['20132-220', '20132-221']"
      :rightInformation="[
        'accordion_exudative_products_information_2',
        'accordion_exudative_products_information_3',
        'accordion_exudative_products_information_4',
      ]"
      :rightButtonLink="
        'https://de.erbe-med.com/productfinder/index.php?openurl=PLM_PRODUKTKATEGORIE%3DInstrument%7CPLM_PRODUKTGRUPPE%3DFlexible%20Sonden%7CPLM_PRODUKTUNTERGRUPPE%3DFiAPC&language=en'
      "
    />
  </div>
</template>

<script>
import ScientificInformationCardRow from "@/components/ScientificInformationCardRow";
import ListWithArrows from "../../components/ListWithArrows.vue";
import AccordionVideoContainer from "../../components/AccordionVideoContainer.vue";
import ProductsForIntervention from "../../components/ProductsForIntervention.vue";

export default {
  name: "ExudativeSection",
  components: {
    ScientificInformationCardRow,
    ListWithArrows,
    AccordionVideoContainer,
    ProductsForIntervention,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss";
.exudative-section {
  display: flex;
  flex-direction: column;
  font-family: $font_nettoRegular;
  background-color: lightgray;
  background: -webkit-radial-gradient(circle center 50%, lightgray, gray);
  background: radial-gradient(circle at center 50%, lightgray, gray);
  align-items: center;
  cursor: default;
  padding-top: 1rem;
}
</style>
